import { controls,grouped } from "../controls";
const vaults = {
label: "Vaults",
pageLabel: "Vaults",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Contact Detail",uid: "contact_detail"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "vault_code",maxlength:30}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Vault Name"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "vault_name",width:"col-sm-4",maxlength:150}),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "vault_code",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Vault Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "vault_name",isRequired:false,width:"col-sm-4",maxlength:150}),
...controls.displayText({ tab: "general", label: "Model",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "model",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Purchase Date",target: "purchase_date",star:false}),
...controls.magicDate({ tab: "general", name: "purchase_date", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Warranty Priod In Months",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "warranty_priod_in_months",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Master Keys Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "master_keys_number",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Branch",star:true}),
...controls.oc({ tab: "general", length:4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", isRequired:true,fastpath:"branches"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display"}),
...controls.displayText({ tab: "general", label: "Vendor",star:true}),
...controls.oc({ tab: "general", c: "Vendor", placeHolder: "Vendor Code", name: "vendor_code", isRequired:true,fastpath:"vendors"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "vendor_display"}),
...controls.displayText({ tab: "contact_detail", label: "Full Name",star:false}),
...controls.text({ tab: "contact_detail",  placeHolder: "", name: "contact_detail.full_name",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "contact_detail", label: "Contact Number",star:false}),
...controls.text({ tab: "contact_detail",  placeHolder: "", name: "contact_detail.contact_number",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "contact_detail", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "contact_detail", label: "Email Address",star:false}),
...controls.text({ tab: "contact_detail",  placeHolder: "", name: "contact_detail.email_address",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "contact_detail", label: "Fax Number",star:false}),
...controls.text({ tab: "contact_detail",  placeHolder: "", name: "contact_detail.fax_number",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "contact_detail", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "contact_detail", label: "Whats App Number",star:false}),
...controls.text({ tab: "contact_detail",  placeHolder: "", name: "contact_detail.whats_app_number",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "contact_detail", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "contact_detail", label: "Designation",star:false}),
...controls.oc({ tab: "contact_detail", c: "Designation", placeHolder: "Designation Code", name: "contact_detail.designation_code", isRequired:false,fastpath:"designations"}),
...controls.showData({ tab: "contact_detail", displaytype: "capital", data: "contact_detail.designation_display"}),
]
,history:{
perPage: 10,
reportHeader: "Vaults",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Vault Code",accessor: "vault_code",},
{Header: "Vault Name",accessor: "vault_name",},
{Header: "Model",accessor: "model",},
{Header: "Purchase Date",accessor: "purchase_date",type:'date'},
{Header: "Warranty Priod In Months",accessor: "warranty_priod_in_months",},
{Header: "Master Keys Number",accessor: "master_keys_number",},
{Header: "Vendor",accessor: "Vault-vendor-vendor_display",},
{Header: "Id",accessor: "Vault-contact_detail-id",},
{Header: "Branch",accessor: "Vault-branch-branch_display",},
{Header: "Vendor Uid",accessor: "Vault-vendor-vendor_uid",},
]}};
export default vaults;